import { render } from "./AnalysisDetails.vue?vue&type=template&id=5cf567e1"
import script from "./AnalysisDetails.vue?vue&type=script&lang=js"
export * from "./AnalysisDetails.vue?vue&type=script&lang=js"

import "./AnalysisDetails.vue?vue&type=style&index=0&id=5cf567e1&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__